"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reportSoldApiToken = exports.getMyViewingDocumentByPropertyApiToken = exports.getMyListingDocumentByPropertyApiToken = exports.getMyViewingsApiToken = exports.getMyListingsApiToken = void 0;
var Api_1 = require("@/api/remote/Api");
exports.getMyListingsApiToken = function (keyword, page, propertyListOrderEnum, propertyListOrderIsAsc, languageCode, token) {
    return Api_1.api().request({
        data: { page: page, keyword: keyword, propertyListOrderEnum: propertyListOrderEnum, propertyListOrderIsAsc: propertyListOrderIsAsc },
        method: 'POST',
        url: languageCode + "/api/myproperty/getmylistings",
        headers: {
            'X-XSRF-TOKEN': token,
        },
    });
};
exports.getMyViewingsApiToken = function (keyword, page, propertyListOrderEnum, propertyListOrderIsAsc, languageCode, token) {
    return Api_1.api().request({
        data: { page: page, keyword: keyword, propertyListOrderEnum: propertyListOrderEnum, propertyListOrderIsAsc: propertyListOrderIsAsc },
        method: 'POST',
        url: languageCode + "/api/myproperty/getmyviewings",
        headers: {
            'X-XSRF-TOKEN': token,
        },
    });
};
exports.getMyListingDocumentByPropertyApiToken = function (propertyId, page, languageCode, token) {
    return Api_1.api().request({
        data: {
            propertyIds: [propertyId],
            page: page
        },
        method: 'POST',
        url: languageCode + "/api/myproperty/getmylistingdocumentbyproperty",
        headers: {
            'X-XSRF-TOKEN': token,
        },
    });
};
exports.getMyViewingDocumentByPropertyApiToken = function (propertyId, page, languageCode, token) {
    return Api_1.api().request({
        data: {
            propertyIds: [propertyId],
            page: page
        },
        method: 'POST',
        url: languageCode + "/api/myproperty/getmyviewingdocumentbyproperty",
        headers: {
            'X-XSRF-TOKEN': token,
        },
    });
};
exports.reportSoldApiToken = function (propertyId, salePrice, leasePrice, soldDate, agency, languageCode, token) {
    return Api_1.api().request({
        data: { propertyId: propertyId, salePrice: salePrice, leasePrice: leasePrice, soldDate: soldDate, agency: agency },
        method: 'POST',
        url: languageCode + "/api/myproperty/reportsold",
        headers: {
            'X-XSRF-TOKEN': token,
        },
    });
};
